export const translations = {
  header: {
    collections: {
      ru: 'КОЛЛЕКЦИИ',
      en: 'COLLECTIONS',
      es: 'COLECCIONES'
    },
    about: {
      ru: 'О БРЕНДЕ',
      en: 'ABOUT',
      es: 'SOBRE NOSOTROS'
    },
    shop: {
      ru: 'МАГАЗИН',
      en: 'SHOP',
      es: 'TIENDA'
    },
    world: {
      ru: 'МИР ALRICHE',
      en: 'ALRICHE WORLD',
      es: 'MUNDO ALRICHE'
    },
    contact: {
      ru: 'КОНТАКТЫ',
      en: 'CONTACT',
      es: 'CONTACTO'
    },
    menuToggleOpen: {
      ru: 'Открыть меню',
      en: 'Open menu',
      es: 'Abrir menú'
    },
    menuToggleClose: {
      ru: 'Закрыть меню',
      en: 'Close menu',
      es: 'Cerrar menú'
    },
    logoHomeLabel: {
      ru: 'На главную ALRICHE',
      en: 'ALRICHE Home',
      es: 'Inicio ALRICHE'
    },
    cart: {
      ru: 'КОРЗИНА',
      en: 'CART',
      es: 'CARRITO'
    }
  },
  headerLeftMenu: {
    festive: {
      ru: 'Праздничные',
      en: 'Festive',
      es: 'Fiesta'
    },
    cocktailDresses: {
      ru: 'Коктейльные платья',
      en: 'Cocktail Dresses',
      es: 'Vestidos de cóctel'
    },
    classicSuits: {
      ru: 'Классические костюмы',
      en: 'Classic Suits',
      es: 'Trajes clásicos'
    },
    perfumes: {
      ru: 'Духи',
      en: 'Perfumes',
      es: 'Perfumes'
    },
    jewelry: {
      ru: 'Ювелирные изделия',
      en: 'Jewelry',
      es: 'Joyería'
    },
    businessSuite: {
      ru: 'Деловой костюм',
      en: 'Business Suite',
      es: 'Traje de negocios'
    },
    cocktailDress: {
      ru: 'Коктейльное платье',
      en: 'Cocktail dress',
      es: 'Vestido de cóctel'
    },
    ladyInRedMenu: {
      ru: 'Леди в красном',
      en: 'Lady in Red',
      es: 'Lady in Red'
    },
    jewelleryFashionDesignerMenu: {
      ru: 'Дизайнер ювелирных украшений и моды',
      en: 'JEWELLERY AND FASHION DESIGNER',
      es: 'JEWELLERY AND FASHION DESIGNER'
    }
  },
  hero: {
    subtitle: {
      ru: 'ДОМ ВЫСОКОЙ МОДЫ',
      en: 'HAUTE COUTURE MAISON',
      es: 'CASA DE ALTA COSTURA'
    },
    title: {
      ru: 'Искусство вечной элегантности',
      en: 'The Art of Timeless Elegance',
      es: 'El Arte de la Elegancia Atemporal'
    },
    description: {
      ru: 'Каждое творение ALRICHE — это симфония безупречного мастерства, где традиции haute couture встречаются с современным видением красоты',
      en: 'Each ALRICHE creation is a symphony of impeccable craftsmanship, where haute couture traditions meet a modern vision of beauty',
      es: 'Cada creación ALRICHE es una sinfonía de artesanía impecable, donde las tradiciones de alta costura se encuentran con una visión moderna de la belleza'
    },
    btnCollections: {
      ru: 'ОТКРЫТЬ КОЛЛЕКЦИИ',
      en: 'DISCOVER COLLECTIONS',
      es: 'DESCUBRIR COLECCIONES'
    },
    btnAppointment: {
      ru: 'ЗАПИСАТЬСЯ НА ВСТРЕЧУ',
      en: 'BOOK APPOINTMENT',
      es: 'RESERVAR CITA'
    },
    scroll: {
      ru: 'ПРОКРУТИТЬ',
      en: 'SCROLL',
      es: 'DESPLAZAR'
    }
  },
  story: {
    title: {
      ru: 'История',
      en: 'History',
      es: 'Historia'
    },
  },
  signatureCollections: {
    title: {
      ru: 'Фирменные коллекции',
      en: 'Signature Collections',
      es: 'Colecciones Exclusivas'
    },
    description: {
      ru: 'Эксклюзивные коллекции, воплощающие квинтэссенцию элегантности и безупречного вкуса. Каждая линия создана в сотрудничестве с мировыми дизайнерами и представляет собой произведение искусства.',
      en: 'Exclusive collections embodying the quintessence of elegance and impeccable taste. Each line is created in collaboration with world designers and is a work of art.',
      es: 'Colecciones exclusivas que encarnan la quintaesencia de la elegancia y el gusto impecable. Cada línea es creada en colaboración con diseñadores mundiales y es una obra de arte.'
    },
    hauteCouture: {
      ru: 'ВЫСОКАЯ МОДА',
      en: 'HAUTE COUTURE',
      es: 'ALTA COSTURA'
    },
    artOfLiving: {
      ru: 'Искусство жизни',
      en: "L'Art de Vivre",
      es: 'El Arte de Vivir'
    },
    artOfLivingDesc: {
      ru: 'Коллекция высокой моды, где каждое платье создается исключительно вручную. Более 300 часов работы мастеров, использование редчайших тканей и драгоценных элементов. Ограниченная серия — всего 12 изделий в год.',
      en: 'A haute couture collection where each dress is created exclusively by hand. More than 300 hours of master work, using the rarest fabrics and precious elements. Limited series - only 12 pieces per year.',
      es: 'Una colección de alta costura donde cada vestido se crea exclusivamente a mano. Más de 300 horas de trabajo maestro, utilizando las telas más raras y elementos preciosos. Serie limitada: solo 12 piezas por año.'
    },
    pretAPorter: {
      ru: 'РОСКОШНОЕ ПРЕТ-А-ПОРТЕ',
      en: 'PRÊT-À-PORTER LUXE',
      es: 'PRÊT-À-PORTER DE LUJO'
    },
    modernEssence: {
      ru: 'Современная суть',
      en: 'Essence Moderne',
      es: 'Esencia Moderna'
    },
    modernEssenceDesc: {
      ru: 'Современная интерпретация классической элегантности. Коллекция для женщин, которые ценят безупречный крой, качественные материалы и утонченный дизайн в повседневной жизни.',
      en: 'A modern interpretation of classic elegance. A collection for women who value impeccable cut, quality materials and refined design in everyday life.',
      es: 'Una interpretación moderna de la elegancia clásica. Una colección para mujeres que valoran el corte impecable, los materiales de calidad y el diseño refinado en la vida cotidiana.'
    },
    accessories: {
      ru: 'АКСЕССУАРЫ МЕЙСОН',
      en: 'ACCESSORIES MAISON',
      es: 'ACCESORIOS MAISON'
    },
    objectsOfArt: {
      ru: 'Предметы искусства',
      en: "Objets d'Art",
      es: 'Objetos de Arte'
    },
    objectsOfArtDesc: {
      ru: 'Коллекция аксессуаров, созданных как произведения искусства. Сумки, украшения и аксессуары, которые становятся семейными реликвиями, передаваемыми из поколения в поколение.',
      en: 'A collection of accessories created as works of art. Bags, jewelry and accessories that become family heirlooms passed down from generation to generation.',
      es: 'Una colección de accesorios creados como obras de arte. Bolsos, joyas y accesorios que se convierten en reliquias familiares transmitidas de generación en generación.'
    },
    btnConsultation: {
      ru: 'Записаться на консультацию',
      en: 'Book a Consultation',
      es: 'Reservar Consulta'
    },
    btnViewCollection: {
      ru: 'Посмотреть коллекцию',
      en: 'View Collection',
      es: 'Ver Colección'
    },
    btnExploreCollection: {
      ru: 'Изучить коллекцию',
      en: 'Explore Collection',
      es: 'Explorar Colección'
    },
    feature1: {
      ru: 'Эксклюзивные ткани от Loro Piana',
      en: 'Exclusive fabrics from Loro Piana',
      es: 'Telas exclusivas de Loro Piana'
    },
    feature2: {
      ru: 'Ручная вышивка золотыми нитями',
      en: 'Hand embroidery with gold threads',
      es: 'Bordado a mano con hilos de oro'
    },
    feature3: {
      ru: 'Персональная примерка в ателье',
      en: 'Personal fitting in atelier',
      es: 'Prueba personal en atelier'
    },
    feature4: {
      ru: 'Итальянские ткани премиум-класса',
      en: 'Premium Italian fabrics',
      es: 'Telas italianas premium'
    },
    feature5: {
      ru: 'Безупречная посадка по фигуре',
      en: 'Impeccable fit',
      es: 'Ajuste impecable'
    },
    feature6: {
      ru: 'Возможность индивидуальной подгонки',
      en: 'Custom tailoring available',
      es: 'Ajuste personalizado disponible'
    },
    feature7: {
      ru: 'Эксклюзивная кожа крокодила и питона',
      en: 'Exclusive crocodile and python leather',
      es: 'Cuero exclusivo de cocodrilo y pitón'
    },
    feature8: {
      ru: 'Фурнитура из золота 18 карат',
      en: '18-karat gold hardware',
      es: 'Herrajes de oro de 18 quilates'
    },
    feature9: {
      ru: 'Персональная гравировка',
      en: 'Personal engraving',
      es: 'Grabado personal'
    },
    stat1: {
      ru: 'Изделий Haute Couture в год',
      en: 'Haute Couture pieces per year',
      es: 'Piezas de Alta Costura al año'
    },
    stat2: {
      ru: 'Часов ручной работы',
      en: 'Hours of handwork',
      es: 'Horas de trabajo manual'
    },
    stat3: {
      ru: 'Стран эксклюзивных поставок',
      en: 'Countries of exclusive supply',
      es: 'Países de suministro exclusivo'
    },
    stat4: {
      ru: 'Возможностей персонализации',
      en: 'Personalization options',
      es: 'Opciones de personalización'
    }
  },
  romanticWhiteCollection: {
    title: {
      ru: 'Романтическая белая коллекция',
      en: 'Romantic White Collection'
    }
  },
  whiteCouture: {
    subtitle: {
      ru: 'Эксклюзивная коллекция в белой палитре, сочетающая архитектурные силуэты и кутюрное исполнение.',
      en: ''
    },
    text1: {
      ru: 'Архитектурные линии, мягкий блеск белой палитры и деликатные акценты золота создают ощущение безупречной чистоты и современного кутюрного силуэта.',
      en: ''
    },
    text2: {
      ru: 'Каждое изделие коллекции создаётся как единственная скульптура на теле: сложные драпировки, продуманные пропорции и безупречный крой подчеркивают естественную грацию движения.',
      en: ''
    },
    text3: {
      ru: 'Костюм-стрейч тянется до трёх размеров. Костюм изготавливается вручную по высоким стандартам высокой моды. Цена: € 900.',
      en: ''
    }
  },
  purpleCouture: {
    subtitle: {
      ru: 'Эксклюзивная коллекция в лавандовой палитре, сочетающая архитектурные силуэты и кутюрное исполнение.',
      en: ''
    },
    text1: {
      ru: 'Архитектурные линии, мягкий блеск белой палитры и деликатные акценты золота создают ощущение безупречной чистоты и современного кутюрного силуэта.',
      en: ''
    },
    text2: {
      ru: 'Каждое изделие коллекции создаётся как единственная скульптура на теле: сложные драпировки, продуманные пропорции и безупречный крой подчеркивают естественную грацию движения.',
      en: ''
    },
    text3: {
      ru: 'Костюм-стрейч тянется до трёх размеров. Костюм изготавливается вручную по высоким стандартам высокой моды. Цена: € 900.',
      en: ''
    }
  },
  featuredCollections: {
    title: {
      ru: 'Избранные коллекции',
      en: 'Featured Collections',
      es: 'Colecciones Destacadas'
    },
    description: {
      ru: 'Каждая коллекция ALRICHE — это история о красоте, силе и индивидуальности современной женщины.',
      en: 'Each ALRICHE collection is a story about beauty, strength and individuality of a modern woman.',
      es: 'Cada colección ALRICHE es una historia sobre belleza, fuerza e individualidad de una mujer moderna.'
    },
    fashion: {
      ru: 'Мода',
      en: 'Fashion',
      es: 'Moda'
    },
    fashionDesc: {
      ru: 'Изысканные силуэты и безупречный крой',
      en: 'Exquisite silhouettes and impeccable cut',
      es: 'Siluetas exquisitas y corte impecable'
    },
    accessories: {
      ru: 'Аксессуары',
      en: 'Accessories',
      es: 'Accesorios'
    },
    accessoriesDesc: {
      ru: 'Детали, которые создают образ',
      en: 'Details that create the look',
      es: 'Detalles que crean el look'
    },
    fragrances: {
      ru: 'Ароматы',
      en: 'Fragrances',
      es: 'Fragancias'
    },
    fragrancesDesc: {
      ru: 'Чувственные композиции для души',
      en: 'Sensual compositions for the soul',
      es: 'Composiciones sensuales para el alma'
    },
    jewelry: {
      ru: 'Украшения',
      en: 'Jewelry',
      es: 'Joyería'
    },
    jewelryDesc: {
      ru: 'Драгоценные акценты для особых моментов',
      en: 'Precious accents for special moments',
      es: 'Acentos preciosos para momentos especiales'
    },
    limited: {
      ru: 'Лимитированная серия',
      en: 'Limited Edition',
      es: 'Edición Limitada'
    },
    limitedDesc: {
      ru: 'Эксклюзивные изделия в ограниченном количестве',
      en: 'Exclusive items in limited quantities',
      es: 'Artículos exclusivos en cantidades limitadas'
    },
    spring: {
      ru: 'Весна 2025',
      en: 'Spring 2025',
      es: 'Primavera 2025'
    },
    springDesc: {
      ru: 'Нежные оттенки и воздушные силуэты',
      en: 'Delicate shades and airy silhouettes',
      es: 'Tonos delicados y siluetas aéreas'
    },
    resort: {
      ru: 'Курортная',
      en: 'Resort',
      es: 'Resort'
    },
    resortDesc: {
      ru: 'Элегантность для отдыха',
      en: 'Elegance for leisure',
      es: 'Elegancia para el ocio'
    },
    bridal: {
      ru: 'Свадебная',
      en: 'Bridal',
      es: 'Nupcial'
    },
    bridalDesc: {
      ru: 'Свадебные платья мечты',
      en: 'Dream wedding dresses',
      es: 'Vestidos de novia de ensueño'
    },
    jewelleryCoutureDescription: {
      ru: 'Ювелирная коллекция ALRICHE, подчеркивающая свет и движение в каждом кадре.',
      en: "ALRICHE’s jewelry collection emphasizes light and movement in every frame.",
      es: 'Colección de joyería de ALRICHE que enfatiza la luz y el movimiento en cada encuadre.'
    },
    redCollectionTitle: {
      ru: 'Красная коллекция',
      en: 'Red collection'
    },
    luxuryHandmakerTitle: {
      ru: 'Коллекция Luxury Handmaker На продажу',
      en: 'Luxury Collection Handmaker For Sale'
    },
    blackAndWhiteTitle: {
      ru: 'Чёрно-белая коллекция',
      en: 'Black and White Collection'
    },
    collectionForSaleTitle: {
      ru: 'Коллекция на заказ',
      en: 'Collection for order'
    },
    btnView: {
      ru: 'Смотреть коллекцию',
      en: 'View Collection',
      es: 'Ver Colección'
    },
    badgeLimited: {
      ru: 'ЛИМИТЕД',
      en: 'LIMITED',
      es: 'LIMITADO'
    },
    badgeNew: {
      ru: 'НОВИНКА',
      en: 'NEW',
      es: 'NUEVO'
    }
  },
  philosophy: {
    title: {
      ru: 'Мир моды',
      en: 'World Of Fashion',
      es: 'Filosofía de la Marca'
    },
    text1: {
      ru: 'ALRICHE — это больше, чем просто бренд. Это философия жизни, где роскошь становится искусством самовыражения. Мы создаём не просто одежду и аксессуары, а инструменты для раскрытия внутренней силы и красоты каждой женщины.',
      en: 'ALRICHE is more than just a brand. It is a philosophy of life, where luxury becomes an art of self-expression. We create not just clothes and accessories, but tools to reveal the inner strength and beauty of every woman.',
      es: 'ALRICHE es más que una marca. Es una filosofía de vida, donde el lujo se convierte en un arte de autoexpresión. Creamos no solo ropa y accesorios, sino herramientas para revelar la fuerza interior y la belleza de cada mujer.'
    },
    text2: {
      ru: 'Я проработала 25 лет в ювелирном бизнесе и архитектуре зданий. Я проектировала как многоэтажные, так и одноэтажные здания. Я также работала над собственными проектами. Я архитектор, дизайнер, технолог и модельер в различных областях.',
      en: "I spent 25 years in the jewelry business and building architecture. I've designed both multi-story and single-story buildings. I've also worked on my own projects. I'm an architect, designer, technologist, and fashion designer in various fields.",
      es: 'Los desfiles de ALRICHE son historias cinematográficas en movimiento: la luz, la sombra y el movimiento de las telas se funden en un solo encuadre, donde cada modelo se convierte en la protagonista de su propia historia.'
    },
    elegance: {
      ru: 'Элегантность',
      en: 'Elegance',
      es: 'Elegancia'
    },
    eleganceDesc: {
      ru: 'Продуманная простота силуэта и чистота линий, которые выглядят безупречно в любом свете.',
      en: 'Considered simplicity of silhouette and purity of lines that look impeccable under any light.',
      es: 'Sencillez estudiada del silueta y pureza de líneas que se ven impecables bajo cualquier luz.'
    },
    quality: {
      ru: 'Качество',
      en: 'Quality',
      es: 'Calidad'
    },
    qualityDesc: {
      ru: 'Ткани высокой моды, ручная отделка и строгий контроль посадки на каждом этапе создания образа.',
      en: 'Haute couture fabrics, hand finishing and rigorous fit control at every stage of creating the look.',
      es: 'Tejidos de alta costura, acabados a mano y un control riguroso del ajuste en cada etapa de creación del look.'
    },
    btnLearnMore: {
      ru: 'Узнать больше',
      en: 'Learn more',
      es: 'Saber más'
    }
  },
  experience: {
    architectureLine: {
      ru: 'Angelina ALriche 25 лет строила и проектировала офисы, магазины, рестораны и высотные дома.',
      en: 'Angelina ALriche spent 25 years designing and building offices, boutiques, restaurants and high-rise buildings.'
    }
  },
  jewelleryFashion: {
    title: {
      ru: 'Дизайнер ювелирных украшений и моды',
      en: 'JEWELLERY and FASHION DESIGNER',
      es: 'JEWELLERY and FASHION DESIGNER'
    }
  },
  clothingProduction: {
    title: {
      ru: 'Наши мастера пошива',
      en: 'Our sewing masters'
    }
  },
  premiumProducts: {
    title: {
      ru: 'Премиальные изделия',
      en: 'Premium Products',
      es: 'Productos Premium'
    },
    description: {
      ru: 'Эксклюзивные предметы роскоши, созданные в единственном экземпляре',
      en: 'Exclusive luxury items created in a single copy',
      es: 'Artículos de lujo exclusivos creados en una sola copia'
    }
  },
  ladyInRed: {
    headingEyebrow: {
      ru: 'Alriche Couture Film',
      en: 'Alriche Couture Film',
      es: 'Alriche Couture Film'
    },
    headingTitle: {
      ru: 'Леди в красном',
      en: 'Lady in Red',
      es: 'Lady in Red'
    },
    badgeLimited: {
      ru: 'Лимитированная история',
      en: 'Limited Story',
      es: 'Historia Limitada'
    },
    filmText1: {
      ru: 'Видеопортрет женственности, силы и изящества. Геройня в алом — как драгоценный камень в вечернем свете: каждый еӗ шаг точен, как высотная портновская линия, а каждое движение оставляет светящийся след.',
      en: 'A video portrait of femininity, strength and grace. The heroine in crimson is like a precious gem in the evening light: every step is as precise as a haute tailoring line, and every movement leaves a luminous trace.'
    },
    filmText2: {
      ru: 'Тонкие отблески золота, мягкая игра света и архитектоника силуэта создают атмосферу кинематографической драмы, в которой главная роль отведена вам.',
      en: 'Subtle glints of gold, the soft play of light and the architectonics of the silhouette create an atmosphere of cinematic drama in which the leading role belongs to you.'
    },
    filmText3: {
      ru: 'Коллекция Lady in Red раскрывает красное не как цвет, а как состояние души — уверенное, притягательное и безупречно элегантное.',
      en: 'The Lady in Red collection reveals red not as a color, but as a state of mind — confident, magnetic and impeccably elegant.'
    },
    btnExplore: {
      ru: 'Исследовать коллекцию',
      en: 'Explore collection'
    },
    noteSound: {
      ru: 'Без звука · Только визуальная история',
      en: 'Sound off · Visual story only'
    }
  },
  newsletter: {
    title: {
      ru: 'Будьте в курсе новинок',
      en: 'Stay Updated',
      es: 'Manténgase Actualizado'
    },
    description: {
      ru: 'Подпишитесь на нашу рассылку и первыми узнавайте о новых коллекциях, эксклюзивных предложениях и событиях мира ALRICHE.',
      en: 'Subscribe to our newsletter and be the first to know about new collections, exclusive offers and ALRICHE world events.',
      es: 'Suscríbase a nuestro boletín y sea el primero en conocer las nuevas colecciones, ofertas exclusivas y eventos del mundo ALRICHE.'
    },
    placeholder: {
      ru: 'Ваш email',
      en: 'Your email',
      es: 'Su correo electrónico'
    },
    btnSubscribe: {
      ru: 'Подписаться',
      en: 'Subscribe',
      es: 'Suscribirse'
    }
  },
  footer: {
    description: {
      ru: 'Роскошь как искусство самовыражения. Премиальный бренд, сочетающий утончённую элегантность и высокое качество.',
      en: 'Luxury as an art of self-expression. A premium brand combining refined elegance and high quality.',
      es: 'Lujo como arte de autoexpresión. Una marca premium que combina elegancia refinada y alta calidad.'
    },
    collections: {
      ru: 'Коллекции',
      en: 'Collections',
      es: 'Colecciones'
    },
    fashion: {
      ru: 'Мода',
      en: 'Fashion',
      es: 'Moda'
    },
    accessories: {
      ru: 'Аксессуары',
      en: 'Accessories',
      es: 'Accesorios'
    },
    fragrances: {
      ru: 'Ароматы',
      en: 'Fragrances',
      es: 'Fragancias'
    },
    jewelry: {
      ru: 'Украшения',
      en: 'Jewelry',
      es: 'Joyería'
    },
    service: {
      ru: 'Сервис',
      en: 'Service',
      es: 'Servicio'
    },
    customerCare: {
      ru: 'Забота о клиентах',
      en: 'Customer Care',
      es: 'Atención al Cliente'
    },
    sizeGuide: {
      ru: 'Таблица размеров',
      en: 'Size Guide',
      es: 'Guía de Tallas'
    },
    shipping: {
      ru: 'Доставка',
      en: 'Shipping',
      es: 'Envío'
    },
    returns: {
      ru: 'Возврат',
      en: 'Returns',
      es: 'Devoluciones'
    },
    contacts: {
      ru: 'Контакты',
      en: 'Contacts',
      es: 'Contactos'
    },
    copyright: {
      ru: '© 2025 ALRICHE. Все права защищены.',
      en: '© 2025 ALRICHE. All rights reserved.',
      es: '© 2025 ALRICHE. Todos los derechos reservados.'
    },
    privacy: {
      ru: 'Политика конфиденциальности',
      en: 'Privacy Policy',
      es: 'Política de Privacidad'
    },
    terms: {
      ru: 'Условия использования',
      en: 'Terms of Use',
      es: 'Términos de Uso'
    }
  }
}

// Auth-specific translations
export const authTranslations = {
  errors: {
    invalidCredentials: {
      ru: 'Неверный email или пароль',
      en: 'Invalid email or password',
      es: 'Email o contraseña incorrectos'
    },
    rateLimitWait: {
      ru: 'В целях безопасности вы можете запросить это снова через {seconds} с.',
      en: 'For security purposes, you can only request this after {seconds} seconds.',
      es: 'Por motivos de seguridad, solo puede solicitar esto después de {seconds} segundos.'
    }
  }
}

